import { GridColDef, GridCellParams } from '@mui/x-data-grid'
import { t } from 'i18next'
import { NavLink, useNavigate } from 'react-router-dom'
import DeleteButton from '../components/common/DeleteButton'
import LaunchIcon from '@mui/icons-material/Launch'
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined'
import { hasRole } from '../utils/checkRole'
import { UserRole } from '../types/keycloak'
import { useSelector } from 'react-redux'
import { formatTitle } from '../utils/formatTitle'

const useColumnsAudit = (
  handleDeleteClick?: (AuditId: string) => void,
  disableActions?: boolean
): GridColDef[] => {
  const navigate = useNavigate()
  const roles = useSelector((state: any) => state.auth.roles)
  disableActions = disableActions ?? false
  return [
    {
      field: 'AuditName',
      headerName: t('tables.auditTable.audit_name'),
      minWidth: 150,
      flex: disableActions ? 2 : 1,
      renderCell: (params: GridCellParams) => (
        <NavLink
          className="line-clamp-2 overflow-hidden text-ellipsis"
          to={`/audit-detail/${params.id}`}
        >
          <strong style={{ color: '#132743' }}>
            {formatTitle(params.value as string)}{' '}
          </strong>
        </NavLink>
      ),
    },
    {
      field: 'Description',
      headerName: t('tables.auditTable.description'),
      minWidth: 150,
      flex: disableActions ? 2 : 1,
      renderCell: (params: GridCellParams) => (
        <span className="line-clamp-2 overflow-hidden text-ellipsis">
          {params.row.Description}
        </span>
      ),
    },
    {
      field: 'MissionName',
      headerName: t('tables.auditTable.mission_name'),
      flex: 1,
      minWidth: disableActions ? 0 : 150,
      renderCell: (params: GridCellParams) => (
        <span className="line-clamp-2 overflow-hidden text-ellipsis">
          {params.row.MissionName}
        </span>
      ),
    },
    ...(!disableActions
      ? [
          {
            field: 'Action',
            headerName: t('tables.auditTable.action'),
            minWidth: 100,
            flex: 0.2,
            renderCell: (params: GridCellParams) => (
              <>
                <LaunchIcon
                  className="iconlaunch"
                  onClick={() => navigate(`/audit-detail/${params.id}`)}
                />
                {hasRole(roles, UserRole.RSSI) ||
                hasRole(roles, UserRole.SSI_TEAM) ||
                hasRole(roles, UserRole.ADMIN) ? (
                  <DriveFileRenameOutlineOutlinedIcon
                    className="iconEdit"
                    onClick={() => navigate(`/audit/${params.id}`)}
                  />
                ) : (
                  ''
                )}
                {hasRole(roles, UserRole.RSSI) ||
                hasRole(roles, UserRole.SSI_TEAM) ||
                hasRole(roles, UserRole.ADMIN) ? (
                  <DeleteButton
                    onDelete={() =>
                      handleDeleteClick &&
                      handleDeleteClick(params.id as string)
                    }
                    item={{
                      entityType: t('audits', { defaultValue: 'Audit' }),
                      name: params.row.AuditName
                        ? formatTitle(String(params.row.AuditName))
                        : undefined,
                      details: [
                        {
                          label: t('deleteConfirm.fields.mission'),
                          value: params.row.MissionName || '—',
                        },
                      ],
                    }}
                  />
                ) : (
                  ''
                )}
              </>
            ),
          },
        ]
      : []),
  ]
}

export default useColumnsAudit
